import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const salesTaxAmountWidget: DashboardWidgetConfiguration = {
  widgetId: "sales.tax-amount",
  name: "Projected sales tax",
  description: "Projected sales tax for the selected dashboard period.",
  apps: [
    "home",
    "sales",
    "crm",
    "finance",
    "invoicing",
    "point-of-sale",
    "subscriptions",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "sales.analysis",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "tax_amount",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Projected tax",
    subtext: "in the last 30 days",
    icon: "percentage",
    color: "warning",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: "0",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
